




































































import { dcb } from '@dcb/jssdk'
import { defineClassComponent } from '@/hooks'
import { parseUrlQueryString } from 'vtils'
import { useWaterfall } from '../waterfall/exports'

export default defineClassComponent<{
  load: any
  track: any
  emptyText?: string
  noCompleteTips?: boolean
}>(
  {
    props: ['load', 'track', 'emptyText', 'noCompleteTips'],
  },
  ({ props }) =>
    class {
      waterfall = useWaterfall('waterfall')

      reload = () => this.waterfall.reload()

      loadData = async (payload: any) => {
        const res = await props.load(payload)
        return (res.list || res).map((item: any) => ({
          ...item,
          isStrategy: item.resType === '07',
          refGoods: parseUrlQueryString(item.targetUrl!.split('?')[1] || ''),
        }))
      }

      handleGoodsClick = (url: string) => {
        dcb.navigateTo({ url })
      }
    },
)
